export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/he-il.lyaml"));
at({ "he-il": { "public": { "sampleString": "\u05DE\u05D7\u05E8\u05D5\u05D6\u05EA \u05DC\u05D3\u05D5\u05D2\u05DE\u05D4" } } });
};